import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=63cf5d86&scoped=true"
import script from "./user-manage.vue?vue&type=script&lang=js"
export * from "./user-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf5d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cf5d86')) {
      api.createRecord('63cf5d86', component.options)
    } else {
      api.reload('63cf5d86', component.options)
    }
    module.hot.accept("./user-manage.vue?vue&type=template&id=63cf5d86&scoped=true", function () {
      api.rerender('63cf5d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/user/user-manage.vue"
export default component.exports